export default __webpack_public_path__ + "static/different_image-e812f99c9f082016ce72e9944d9d7d98.png";